import GridReadpoints from "../readpoint/component/ReadpointGrid";
import GridDevices from "./entities/Devices";
import GridBizLocations from "./entities/BizLocations";
import GridCheckpoints from "./entities/Checkpoints";
import GridTransactions from "../transaction/component/TransactionGrid";
import GridProductTypes from "./entities/ProductTypes";
import GridGateway from "../gateways/GridGateway";
import GridStockLevels from "../stockLevel/StockLevelGrid";
import GridDashboardTemplates from "./entities/DashboardTemplates";
import GridCompanies from "./entities/Companies";
import ApplicationUserGrid
  from "../user/application/component/ApplicationUserGrid";
import Objects from "../utils/Objects";
import NodeGrid from "../gateways/node/NodesGrid";
import MapGrid from "../map/MapGrid";
import PolygonGrid from "../map/polygon/PolygonGrid";
import NodePingsGrid from "../gateways/node/NodePingsGrid";
import IntegrationMessageGrid
  from "../integration/messages/IntegrationMessageGrid";
import IntegrationConfigurationGrid
  from "../integration/configuration/IntegrationConfigurationGrid";
import BalanceByBizLocationGrid from "../balance/BalanceByBizLocationGrid";
import BalanceByProductTypeGrid from "../balance/BalanceByProductTypeGrid";
import BalanceByAssetGrid from "../balance/BalanceByAssetGrid";
import IntegrationUserGrid
  from "../user/integration/component/IntegrationUserGrid";
import MovementOrderGrid from "../movementOrder/component/MovementOrderGrid";
import TransactionPeddingActionGrid
  from "../transaction/component/TransactionPeddingActionGrid";
import PolicyEventGrid from "../bluzone/PolicyEventGrid";
import MovementByProductTypeGird from "./entities/MovementByProductTypeGird";
import MovementOrderByTransaction
  from '../customGrid/entities/MovementOrderByProductType'
import DispositionsGrid from "./entities/DispositionsGrid";
import BizStepGrid from "./entities/BizStepGrid";
import InventoryGrid from "./entities/InventoryGrid";
import NodeActionGrid from "../gateways/node/NodeActionGrid";
import AssetGrid from "../assets/AssetGrid";
import TransactionsItemsGrid from "./entities/TransactionsItemsGrid";
import SensingGrid from "./entities/SensingGrid";
import CompanyConfigurationGrid from "./entities/CompanyConfigurationGrid";
import {AlertGroupGridPage} from "../pages/Groups/AlertGroupGridPage";
import {ConfigurationAlertTriggerGridTemplate} from "../pages/Alerts/AlertsTriggerGridPage";
import {AlertsGridTemplate} from "../pages/Alerts/AlertsGridTemplate";
import MovedProductsGrid from "./entities/MovedProductsGrid";

export default class GridEntityService {

  static entities = {
    'balance': BalanceByBizLocationGrid,
    'balance-by-biz-locations': BalanceByBizLocationGrid,
    'balance-by-product-types': BalanceByProductTypeGrid,
    'biz-locations': GridBizLocations,
    'balance-by-assets': BalanceByAssetGrid,
    'company-configurations': CompanyConfigurationGrid,
    'all-assets': AssetGrid,
    'movement-orders': MovementOrderGrid,
    'companies': GridCompanies,
    'checkpoints': GridCheckpoints,
    'dashboard-templates': GridDashboardTemplates,
    'devices': GridDevices,
    'product-types': GridProductTypes,
    'readpoints': GridReadpoints,
    'stock-levels': GridStockLevels,
    'transactions': GridTransactions,
    'users': ApplicationUserGrid,
    'integration-users': IntegrationUserGrid,
    'gateways': GridGateway,
    'nodes': NodeGrid,
    'nodes-actions': NodeActionGrid,
    'maps': MapGrid,
    'polygons': PolygonGrid,
    'node-pings': NodePingsGrid,
    'integration-messages': IntegrationMessageGrid,
    'integration-configurations': IntegrationConfigurationGrid,
    'pending-transactions': TransactionPeddingActionGrid,
    'policy-events': PolicyEventGrid,
    'alerts-triggers': ConfigurationAlertTriggerGridTemplate,
    'alerts': AlertsGridTemplate,
    'notifications-groups': AlertGroupGridPage,
    'moved-products' : MovedProductsGrid,
    'movement-by-product-type': MovementByProductTypeGird,
    'movement-order-by-transaction': MovementOrderByTransaction,
    'dispositions': DispositionsGrid,
    'biz-steps': BizStepGrid,
    'inventories': InventoryGrid,
    'transactions-items': TransactionsItemsGrid,
    'sensing': SensingGrid
  };

  static getEntity(entityName) {
    const entity = GridEntityService.entities[entityName];
    if (Objects.isNullOrUndefined(entity)) {
      throw new Error('Entidade não identificada: ' + entityName);
    }
    return new entity();
  }

}



// WEBPACK FOOTER //
// ./src/customGrid/GridEntityService.js